export interface TeachingMaterial {
  title: string;
  kind: string;
  url: string;
}
export function teachingMaterials(body: string): TeachingMaterial[] {
  const items: TeachingMaterial[] = [];
  const seen = new Set<string>();
  for (const match of body.matchAll(
    /\[(Slides|Handout|Worksheet|Reference|Teaching material):\s*([^\]\n]+)\]\(([^\s)]+)\)/gi,
  )) {
    const raw = match[3]!;
    let url: string;
    if (
      /^\/teaching-materials\/[a-zA-Z0-9_./-]+\.pdf$/.test(raw) &&
      !raw.includes("..")
    )
      url = raw;
    else {
      try {
        const parsed = new URL(raw);
        if (parsed.protocol !== "https:" || parsed.username || parsed.password)
          continue;
        url = parsed.href;
      } catch {
        continue;
      }
    }
    if (seen.has(url)) continue;
    seen.add(url);
    items.push({ kind: match[1]!, title: match[2]!.trim(), url });
  }
  return items;
}
export function inlineSlidesUrl(url: string, origin: string): string | null {
  try {
    const parsed = new URL(url, origin);
    return parsed.origin === origin &&
      parsed.pathname.startsWith("/teaching-materials/") &&
      parsed.pathname.endsWith(".pdf")
      ? parsed.href
      : null;
  } catch {
    return null;
  }
}
export function teachingNotes(body: string): string {
  return body
    .replace(
      /\[(Slides|Handout|Worksheet|Reference|Teaching material):\s*([^\]\n]+)\]\(([^\s)]+)\)/gi,
      (value) => (teachingMaterials(value).length ? "" : value),
    )
    .trim();
}
